/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Post_Purchase_Check_InboxInputs */

const en_post_purchase_check_inbox = /** @type {(inputs: Post_Purchase_Check_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your inbox. We'll send you an email with download links`)
};

const es_post_purchase_check_inbox = /** @type {(inputs: Post_Purchase_Check_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa tu correo. Te enviaremos un email con enlaces de descarga`)
};

/**
* | output |
* | --- |
* | "Check your inbox. We'll send you an email with download links" |
*
* @param {Post_Purchase_Check_InboxInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const post_purchase_check_inbox = /** @type {((inputs?: Post_Purchase_Check_InboxInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Post_Purchase_Check_InboxInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_post_purchase_check_inbox(inputs)
	return en_post_purchase_check_inbox(inputs)
});